import React, { useMemo } from 'react';
import { isMobile } from '@/utils/detect';
import { CnPage } from '../cn-page';
import { getComponentName } from '@/utils/get-component-name';
const isMobileStatus = isMobile();
export const CnDemoPage = (props) => {
    const { title, noPadding: noPaddingProps, children } = props;
    const noPadding = useMemo(() => {
        if (typeof noPaddingProps === 'boolean')
            return;
        let temp;
        React.Children.forEach(children, (item) => {
            if (typeof temp === 'boolean')
                return;
            if (getComponentName(item) === 'CnDemoBlock') {
                temp = true;
            }
        });
        return temp;
    }, [noPaddingProps, children]);
    if (title && isMobileStatus) {
        document.title = title;
    }
    return React.createElement(CnPage, { noPadding: noPadding }, children);
};
